module.exports = __webpack_public_path__ + "static/media/logo.6f5a0255.png";